import script from "./CheckCompany1.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckCompany1.vue?vue&type=script&lang=ts&setup=true"

import "./CheckCompany1.vue?vue&type=style&index=0&id=3a421643&lang=less&scoped=true"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a421643"]])

export default __exports__